import PropTypes from 'prop-types'
import { forwardRef } from 'react'
import { Modal, Box } from '@mui/material'
import { useSelector } from 'react-redux'

const SIZE_PX = { sm: 560, md: 720, lg: 960, xl: 1200 }

const baseStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 'clamp(920px, 70vw, 1040px)',
  maxHeight: '90vh',
  overflowY: 'auto',
  overflowX: 'hidden',
  bgcolor: 'background.paper',
  borderRadius: 8,
  boxShadow: 24,
  p: 3
}
const DEFAULT_MAX_WIDTH = { xs: '92vw', sm: 720, md:960, lg:1140 }
const MainModal = forwardRef(
  (
    {
      aria_labelledby = 'modal-modal-title',
      aria_describedby = 'modal-modal-description',
      open = false,
      onClose = () => {},
      children,
      styleBody,
      maxWidth = DEFAULT_MAX_WIDTH
    },
    ref
  ) => {
    const customization = useSelector((state) => state.customization)
    const resolvedMax =
      typeof maxWidth === 'string' ? SIZE_PX[maxWidth] || 1040 : maxWidth

    return (
      <Modal
        ref={ref}
        open={open}
        onClose={onClose}
        aria-labelledby={aria_labelledby}
        aria-describedby={aria_describedby}
      >
        <Box
           sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: maxWidth,
            maxWidth: 'calc(100vw - 48px)',
            maxHeight: '90vh',
            overflowY: 'auto',
            bgcolor: 'background.paper',
            borderRadius: `${customization.borderRadius}px`,
            boxShadow: 24,
            p: 3,
            ...styleBody
          }}
        >
          {children}
        </Box>
      </Modal>
    )
  }
)

MainModal.propTypes = {
  aria_labelledby: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.object]),
  aria_describedby: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.object]),
  open: PropTypes.bool,
  onClose: PropTypes.func,
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object]),
  fullWidth: PropTypes.bool
}

export default MainModal
